export default __webpack_public_path__ + "static/media/eye-close.623e981f.png";